const countryOptions = [
  { ID: 1, name: "United States", countryCode: "US", flag: "🇺🇸" },
  { ID: 2, name: "Canada", countryCode: "CA", flag: "🇨🇦" },
  { ID: 3, name: "Australia", countryCode: "AU", flag: "🇦🇺" },
  { ID: 4, name: "United Arab Emirates", countryCode: "AE", flag: "🇦🇪" },
  { ID: 5, name: "United Kingdom", countryCode: "UK", flag: "🇬🇧" },
  { ID: 6, name: "Antigua And Barbuda", countryCode: "AG", flag: "🇦🇬" },
  { ID: 7, name: "Singapore", countryCode: "SG", flag: "🇸🇬" },
  { ID: 8, name: "Bahamas", countryCode: "BS", flag: "🇧🇸" },
  { ID: 9, name: "Mexico", countryCode: "MX", flag: "🇲🇽" },
];

const countryOptionsByID = Object.fromEntries(
  countryOptions.map((option) => [option.ID, option])
);

export { countryOptions, countryOptionsByID };
